export const DEFAULT_DOCUMENT_OPTIONS = { 
    isEvalSupported: false,
};
